import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import DelayedSuspenseFallback from '@/components/DelayedSuspenseFallback';
import RedirectToAccountCenter from '@/components/RedirectToAccountCenter';
import { EnterpriseSubscriptionTabs } from '@/consts';
import { isCloud, isDevFeaturesEnabled } from '@/consts/env';
import ProtectedRoutes from '@/containers/ProtectedRoutes';
import { GlobalAnonymousRoute, GlobalRoute } from '@/contexts/TenantsProvider';
import { OnboardingApp } from '@/onboarding';
import AcceptInvitation from '@/pages/AcceptInvitation';
import Callback from '@/pages/Callback';
import CheckoutSuccessCallback from '@/pages/CheckoutSuccessCallback';
import ExternalGoogleOneTapLanding from '@/pages/ExternalGoogleOneTapLanding';
import OneTimeTokenLanding from '@/pages/OneTimeTokenLanding';

import styles from './AppRoutes.module.scss';
import ConsoleSso from './pages/ConsoleSso';
import ConsoleSsoDetails from './pages/ConsoleSso/Details';
import DeleteAccount from './pages/DeleteAccount';
import EnterpriseSubscription from './pages/EnterpriseSubscription';
import BillingHistory from './pages/EnterpriseSubscription/BillingHistory';
import Subscription from './pages/EnterpriseSubscription/Subscription';
import Main from './pages/Main';
import SocialDemoCallback from './pages/SocialDemoCallback';

/** Renders necessary routes when the user is not in a tenant context. */
function AppRoutes() {
  return (
    <div className={styles.app}>
      <Suspense fallback={<DelayedSuspenseFallback />}>
        <Routes>
          <Route path={GlobalAnonymousRoute.Callback} element={<Callback />} />
          <Route path={GlobalAnonymousRoute.SocialDemoCallback} element={<SocialDemoCallback />} />
          <Route
            path={GlobalAnonymousRoute.OneTimeTokenLanding}
            element={<OneTimeTokenLanding />}
          />
          <Route
            path={GlobalAnonymousRoute.ExternalGoogleOneTapLanding}
            element={<ExternalGoogleOneTapLanding />}
          />
          <Route
            path={`${GlobalRoute.AcceptInvitation}/:invitationId`}
            element={<AcceptInvitation />}
          />
          <Route element={<ProtectedRoutes />}>
            {/* Console SSO */}
            {isCloud && isDevFeaturesEnabled && (
              <>
                <Route path={GlobalRoute.ConsoleSso} element={<ConsoleSso />} />
                <Route
                  path={`${GlobalRoute.ConsoleSso}/:connectorId/:tab?`}
                  element={<ConsoleSsoDetails />}
                />
              </>
            )}
            <Route path={GlobalRoute.Profile + '/*'} element={<RedirectToAccountCenter />} />
            <Route
              path={GlobalRoute.CheckoutSuccessCallback}
              element={<CheckoutSuccessCallback />}
            />
            <Route path={GlobalRoute.Onboarding + '/*'} element={<OnboardingApp />} />
            <Route path={GlobalRoute.DeleteAccount} element={<DeleteAccount />} />
            <Route index element={<Main />} />
            <Route
              path={`${GlobalRoute.EnterpriseSubscription}/:logtoEnterpriseId`}
              element={<EnterpriseSubscription />}
            >
              <Route
                index
                element={<Navigate replace to={EnterpriseSubscriptionTabs.Subscription} />}
              />
              <Route path={EnterpriseSubscriptionTabs.Subscription} element={<Subscription />} />
              <Route
                path={EnterpriseSubscriptionTabs.BillingHistory}
                element={<BillingHistory />}
              />
            </Route>
          </Route>
        </Routes>
      </Suspense>
    </div>
  );
}

export default AppRoutes;
